import { render, staticRenderFns } from "./BacklogView.vue?vue&type=template&id=7d74a4b0&"
import script from "./BacklogView.vue?vue&type=script&lang=js&"
export * from "./BacklogView.vue?vue&type=script&lang=js&"
import style0 from "./BacklogView.vue?vue&type=style&index=0&id=7d74a4b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports